import { EnvironmentProviders, ErrorHandler, makeEnvironmentProviders } from '@angular/core';
import { ClientErrorInterceptor } from './client-error.interceptor';
import { ExceptionService } from './exception.service';

export const provideDataAccessError: () => EnvironmentProviders = () =>
  makeEnvironmentProviders([ExceptionService, { provide: ErrorHandler, useClass: ClientErrorInterceptor }]);
